import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({
    providedIn: "root",
})
export class DocumentService {
    // Lista de domínios, se não existir na lista, seta Estácio como padrão
    /*
    https://consultadocumentosdigitais.area1.br (curriculo | hed)
    https://consultadocumentosdigitais.estacio.br (curriculo | hed)
    https://consultadocumentosdigitais.facieducacional.com.br (curriculo | /hed)
    https://consultadocumentosdigitais.facimp.com.br (curriculo | /hed)
    https://consultadocumentosdigitais.faculdadedamasio.com.br (curriculo | hed)
    https://consultadocumentosdigitais.fmfeducacional.com.br (curriculo | hed)
    https://consultadocumentosdigitais.ibmec.br (curriculo | hed)
    https://consultadocumentosdigitais.unifacid.com.br (curriculo | hed)
    https://consultadocumentosdigitais.unifanor.com.br (curriculo | hed)
    https://consultadocumentosdigitais.unifavip.com.br (curriculo | hed)
    https://consultadocumentosdigitais.unifbv.com.br (curriculo | hed)
    https://consultadocumentosdigitais.unimetrocamp.com.br (curriculo | hed)
    https://consultadocumentosdigitais.uniruy.com.br (curriculo | hed)
    https://consultadocumentosdigitais.unitoledo.br (curriculo | hed)
    https://consultadocumentosdigitais.newtonpaiva.br (curriculo | hed)
    */

    domainList = [
        // Localhost (alterar valores para fins de teste local)
        {
            codigo: 1,
            name: "Estácio",
            path: "estacio",
            identifier: "localhost",
            url: "localhost",
        },

        // Estácio
        {
            codigo: 1,
            name: "Estácio",
            path: "estacio",
            identifier: ".estacio.",
            url: "estacio.br",
        },

        // IBMEC
        {
            codigo: 3,
            name: "IBMEC",
            path: "ibmec",
            identifier: ".ibmec.",
            url: "ibmec.br",
        },

        // Damásio
        {
            codigo: 4,
            name: "Faculdade Damásio",
            path: "damasio",
            identifier: ".damasio.",
            url: "faculdadedamasio.com.br",
        },
        {
            codigo: 4,
            name: "Faculdade Damásio",
            path: "damasio",
            identifier: ".faculdadedamasio.",
            url: "faculdadedamasio.com.br",
        },

        // Área 1
        {
            codigo: 5,
            name: "Area 1",
            path: "area1",
            identifier: ".area1.",
            url: "area1.br",
        },

        // Wyden
        {
            codigo: 2,
            name: "Unitoledo",
            path: "unitoledo",
            identifier: ".unitoledo.",
            url: "unitoledo.br",
        },
        {
            codigo: 6,
            name: "UniFanor",
            path: "unifanor",
            identifier: ".unifanor.",
            url: "unifanor.com.br",
        },
        {
            codigo: 7,
            name: "UniFBV",
            path: "unifbv",
            identifier: ".unifbv.",
            url: "unifbv.com.br",
        },
        {
            codigo: 8,
            name: "UniFacid",
            path: "unifacid",
            identifier: ".unifacid.",
            url: "unifacid.com.br",
        },
        {
            codigo: 9,
            name: "Faculdade Martha Falcão",
            path: "fmf",
            identifier: ".fmfeducacional.",
            url: "fmfeducacional.com.br",
        },
        {
            codigo: 10,
            name: "Faculdade Faci",
            path: "faci",
            identifier: ".facieducacional.",
            url: "facieducacional.com.br",
        },
        {
            codigo: 11,
            name: "UniMetrocamp",
            path: "unimetrocamp",
            identifier: ".unimetrocamp.",
            url: "unimetrocamp.com.br",
        },
        {
            codigo: 12,
            name: "Facimp",
            path: "facimp",
            identifier: ".facimp.",
            url: "facimp.com.br",
        },
        {
            codigo: 13,
            name: "UniRuy",
            path: "uniruy",
            identifier: ".uniruy.",
            url: "uniruy.com.br",
        },
        {
            codigo: 14,
            name: "UniFavip",
            path: "unifavip",
            identifier: ".unifavip.",
            url: "unifavip.com.br",
        },
        {
            codigo: 17,
            name: "Newton Paiva",
            path: "newton",
            identifier: ".newtonpaiva.",
            url: "newtonpaiva.br",
        },
    ];

    constructor(@Inject(DOCUMENT) private document: Document) {}

    getIES() {
        let domain = this.domainList.find(
            (obj) => this.document.domain.indexOf(obj.identifier) > -1
        );

        if (!domain) {
            domain = this.domainList.find(
                (obj) => obj.identifier === "localhost"
            );
        }

        return domain;
    }

    gatFavicon(ies: string) {
        this.document
            .getElementById("icon")
            ?.setAttribute("href", `assets/ies/${ies}/favicon.png`);
    }
}
